import { Component, h } from '@stencil/core';

@Component({
  tag: 'ugc-review-summary-skeleton',
  shadow: false,
})
export class UgcReviewSummarySkeleton {
  render() {
    return (
      <div class="p-16">
        <div class="flex-row-center-center gap-16">
          <ugc-skeleton width="75" height="45.5" customStyle={{ borderRadius: '100px' }} />
          <div class="flex-col-center-start">
            <div class="mb-8 flex-row-start-center gap-2">
              {[0, 1, 2, 3, 4].map(item => (
                <ugc-skeleton width="24" height="24" isCircle key={item} />
              ))}
            </div>
            <ugc-skeleton width="175" height="12.25" />
          </div>
        </div>
      </div>
    );
  }
}
